// Kibocsátó (számlatömb) badge — a jel a KÖZÖS badge-katalógusból (`domain-badge.tsx`, `invoiceIssuer`). A MOR, az
// MDIG és az előtag nélküli `none` ugyanaz a semleges jelvény; a `none` címkéje „—" (nem hiba, hanem a Számlázz.hu
// előtag nélküli számlatömbje). A számlák listája és a hozzárendelések „Számlánként" nézete is ezt használja.
import { type TFunction } from 'i18next';

import { DomainBadge } from '@/components/shared/domain-badge';

export function InvoiceIssuerBadge({
  issuerKey,
  t,
  className,
}: {
  /** A nyers kibocsátó-kulcs (`MOR` · `MDIG` · `none`); hiányzó → `none`. */
  issuerKey: string | null | undefined;
  t: TFunction;
  className?: string;
}): JSX.Element {
  const key = issuerKey ?? 'none';
  return (
    <DomainBadge
      kind="invoiceIssuer"
      value={key}
      label={t(`invoices.issuerLabel.${key}`, { defaultValue: key })}
      className={className}
    />
  );
}
